import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

import { TableColumn, TableRowSelectorDirective, LegacyTableModule } from 'remarketing-ui-components-lib';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { AmbassadorResponseModalComponent, ModalVariant } from '../ambassador-response-modal/ambassador-response-modal.component';
import { RemoveAuthorizedAmbassadorModalComponent } from '../remove-authorized-ambassador-modal/remove-authorized-ambassador-modal.component';
import { closeDrawer, toggleDrawer } from '../../utils/drawer.utils';
import { DateUtilsService, AuthorizedAmbassador, AmbassadorService} from 'remarketing-angular-library';


@Component({
    selector: 'app-authorized-ambassadors',
    templateUrl: './authorized-ambassadors.component.html',
    styleUrls: ['./authorized-ambassadors.component.scss'],
    imports: [TranslocoDirective, LegacyTableModule, RemoveAuthorizedAmbassadorModalComponent, AmbassadorResponseModalComponent]
})
export class AuthorizedAmbassadorsComponent implements AfterViewInit {
  private readonly destroyed$ = new Subject();

  @ViewChild(AmbassadorResponseModalComponent) ambassadorResponseModalComponent: AmbassadorResponseModalComponent;
  @ViewChild(RemoveAuthorizedAmbassadorModalComponent)
    removeAuthorizedAmbassadorModal: RemoveAuthorizedAmbassadorModalComponent;
  @ViewChildren(TableRowSelectorDirective) drawers: QueryList<TableRowSelectorDirective>;

  public columns: TableColumn[] = [];

  public cardConfig = {
    options: {
      fullWidth: true,
      showLabel: false
    }
  };

  public ambassadors: Array<AuthorizedAmbassador> = [];

  constructor(
    private readonly ambassadorService: AmbassadorService,
    private readonly translocoService: TranslocoService,
    private readonly analyticsService: AnalyticsService,
    readonly dateUtilService: DateUtilsService
  ) {
    this.getTranslations();
  }

  ngAfterViewInit(): void {
    this.getAuthorizedAmbassadors();
  }

  getAuthorizedAmbassadors(): void {
    this.ambassadorService.getAuthorizedAmbassadors().pipe(take(1)).subscribe((response: any) => {
      if (response && response.ambassadors) {
        this.ambassadors = response.ambassadors;
      }
    });
  }

  showSuccess(name: string) {
    this.ambassadorResponseModalComponent.show(name, ModalVariant.REMOVED);
  }

  reformatPhone(phone: string): string {
    if (phone) {
      phone = phone.replace(/-/g, '');
      if (phone.length > 0) {
        if (phone.length === 11) {
          phone = `(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
          return phone;
        } else {
          phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
          return phone;
        }
      }
    }
    return undefined;
  }

  formatDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  openModal(ambassador: AuthorizedAmbassador) {
    this.removeAuthorizedAmbassadorModal.show(ambassador);
  }

  setNewAuthorizedAmbassadors(ambassadors: Array<AuthorizedAmbassador>) {
    this.ambassadors = ambassadors;
  }

  toggleDrawer(index: number): void {
    toggleDrawer(this.drawers, index, this.analyticsService);
  }

  closeDrawer(index: number): void {
    closeDrawer(this.drawers, index);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getTranslations(): void {
    this.translocoService.selectTranslateObject('ambassadorAuthorization.tableColumns').subscribe((translate: any) => {
      this.columns = [
        { key: 'name', label: translate.name },
        { key: 'phone', label: translate.phone },
        { key: 'email', label: translate.email },
        { key: 'dateAuthorized', label: translate.dateAuthorized },
        { key: 'actions', label: translate.actions }
      ];
    });
  }
}
